export default __webpack_public_path__ + "static/media/Local Road - Bridge.6e17f7e4.svg";